import { render, staticRenderFns } from "./IncidentQuestion.vue?vue&type=template&id=93f825c2&scoped=true"
import script from "./IncidentQuestion.vue?vue&type=script&lang=js"
export * from "./IncidentQuestion.vue?vue&type=script&lang=js"
import style0 from "./IncidentQuestion.vue?vue&type=style&index=0&id=93f825c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f825c2",
  null
  
)

export default component.exports